import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import LabTechTags from 'components/CIMSTags/common/LabTechTags'
import { TestingLab } from '../TestingLabsContext'
import { useUserDeleted } from 'hooks/useUserDeleted'

type LabTech = TestingLab['labTechs'][0]

export function useColumns(): CIMSColumn<TestingLab>[] {
  const deleted = useUserDeleted()
  return [
    useNameColumn({
      help: HelpMessage.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    {
      title: 'Lab Techs',
      render: ({ labTechs }) => <LabTechTags labTechs={labTechs} />,
      help: HelpMessage.Concrete.LabTechs.TestingLabs.LabTechs,
      filter: {
        type: 'default',
        with: 'callback',
        onFilter: (value, { labTechs }) =>
          labTechs.some(({ id }) => id === value),
        items: (records) => [
          {
            text: 'Users',
            value: 'users',
            children: records
              .flatMap(({ labTechs }) => labTechs)
              .reduce((users, { user, name, id }) => {
                if (!!user) users.push({ user, name, id })
                return users
              }, Array<Required<Pick<LabTech, 'user' | 'id' | 'name'>>>())
              .map(({ id, user, name }) => {
                const inactive = !!user && deleted(user)
                const tooltip = user?.mail
                return {
                  text: name,
                  value: id,
                  tooltip: inactive
                    ? `${tooltip ? tooltip + ' ' : ''}(Inactive)`
                    : tooltip,
                }
              }),
          },
          {
            text: 'Generics',
            value: 'generics',
            children: records
              .flatMap(({ labTechs }) => labTechs)
              .reduce((generics, { id, name, user }) => {
                if (!user) generics.push({ id, name })
                return generics
              }, Array<Pick<LabTech, 'id' | 'name'>>())
              .map(({ id, name }) => ({ text: name, value: id })),
          },
        ],
      },
    },
  ]
}
